import Layout from "../Components/Reuseable/layout";
import "../Components/CSS/pagesCSS/about.css";
import Footer from "../Components/Reuseable/Footer.jsx";
import CoptRight from "../Components/Reuseable/Copyrights";
import "../Components/CSS/pagesCSS/horse.css";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Moment from "react-moment";
import {
  fetchowner,
  STATUSES,
} from "../../Webiste/redux/getReducer/getOwnerSlice";

import Cookies from "js-cookie";
import { Modal } from "react-bootstrap";
import Lottie from "lottie-react";
import Animate from "../assets/loader.json";
import OwnerDetail from "./OwnerDetail";
import { useTranslation } from "react-i18next";
import DefaultImg from "../assets/default.png";
import Pagination from "./Pagination";
import axios from "axios";

import { getBaseUrl } from "../service/apiUrl";
const Owner = () => {
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");
  const [pageNumber, setPageNumber] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [TotalCount, setTotalCount] = useState()
  const [TotalPages, setTotalPages] = useState()

  const [show, setShow] = useState(false);
  const [modaldata, setmodaldata] = useState();
  const handleClose = () => setShow(false);
  const handleShow = async (data) => {
    setmodaldata(data);
    await setShow(true);
  };
  const dispatch = useDispatch();
  const { data: owner, status } = useSelector((state) => state.owner);

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(11);
  const [TotalData, setTotalData] = useState();


  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const GetSearch = async () => {

    const response = await axios.get(
      `${getBaseUrl()}/SearchOwner`
    );


    setTotalCount(response.data.totalcount)
    const TotalPagesData = response.data.totalPages;
    setTotalPages(TotalPagesData)

  };

  useEffect(() => {
    dispatch(fetchowner({ currentPage }));
    GetSearch({ currentPage })
  }, [currentPage, dispatch]);



  if (status === STATUSES.LOADING) {
    return <Lottie animationData={Animate} loop={true} className="load" />;
  }
  if (status === STATUSES.ERROR) {
    return (
      <h2
        style={{
          margin: "100px",
        }}
      >
        Something went wrong!
      </h2>
    );
  }

  return (
    <>
      {/* <Layout /> */}
      <div className="aboutpage">
        <div className="aboutpageheader">
          <h2>Saddle Battle Owner</h2>
        </div>
        <div className="aboutpagesection">
          <div className="horseTable">


            <table id="customers">
              <tr>
                <th>{t("Name")}</th>
                {/* <th>{t("Age")}</th> */}
                <th>{t("Title")} </th>
                <th>{t("Short Name")} </th>
                <th>{t("Registration Date")} </th>
                <th>{t("Nationality")}</th>
                <th>{t("Image")}</th>
              </tr>
              {owner.map((item) => {
                return (
                  <tr
                    onClick={() => handleShow(item)}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <td>
                      {cookiedata === "en"
                        ? item.NameEn
                          ? item.NameEn
                          : <>- </>
                        : item.NameAr
                          ? item.NameAr
                          : <>- </>}{" "}
                    </td>
                    {/* <td>
                      <Moment fromNow ago>
                        {item.DOB}
                      </Moment>
                    </td> */}
                    <td>
                      {cookiedata === "en"
                        ? item.TitleEn
                          ? item.TitleEn
                          : <>- </>
                        : item.TitleAr
                          ? item.TitleAr
                          : <>- </>}
                    </td>
                    <td>
                      {cookiedata === "en"
                        ? item.ShortEn
                          ? item.ShortEn
                          : <>- </>
                        : item.ShortAr
                          ? item.ShortAr
                          : <>- </>}
                    </td>
                    <td> {item.RegistrationDate} </td>
                    <td>
                      {cookiedata === "en"
                        ? item.OwnerDataNationalityData.NameEn
                          ? item.OwnerDataNationalityData.NameEn
                          : <>- </>
                        : item.OwnerDataNationalityData.NameAr
                          ? item.OwnerDataNationalityData.NameAr
                          : <>- </>}
                    </td>
                    <td>
                      <img
                        src={item.image ? item.image : DefaultImg}
                        alt=""
                        style={{
                          height: "30px",
                          width: "30px",
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
        </div>
        <Pagination
          postsPerPage={postsPerPage}
          totalPosts={TotalCount}
          paginate={paginate}
          currentPage={currentPage}
          TotalPages={TotalPages}
        />

        <Modal
          show={show}
          onHide={handleClose}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="popupheader" closeButton>
            <h3>Owner Detail</h3>
          </Modal.Header>
          <Modal.Body>
            <OwnerDetail data={modaldata} />
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      </div>
      <Footer />
      <CoptRight />
    </>
  );
};

export default Owner;
